import * as React from 'react';
import { connect } from 'react-redux';
import { Modal, Input, Table, Spin } from 'antd';
import { getSupplierItems } from '../../../../../HttpRequests/supplierItems';
import { addProcurementItem } from '../../../State/procurementItems';
import { hideCatalogPicker } from '../../../State/showCatalogPicker';

class CatalogPicker extends React.PureComponent {
  state = {
    search: '',
    items: [],
    loading: false,
  }

  componentDidMount() {
    this.fetchItems('');
  }

  fetchItems = (search) => {
    this.setState({ loading: true });
    const params = { search, include: 'supplier', per_page: 100, active: 1 };
    getSupplierItems({ params })
      .then(response => {
        this.setState({ items: response.data || [], loading: false });
      })
      .catch(() => this.setState({ loading: false }));
  }

  onSearch = (e) => {
    const search = e.target.value;
    this.setState({ search });
    if (this.searchTimer) clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => this.fetchItems(search), 300);
  }

  onSelectItem = (record) => {
    const { procurementItems, dispatch } = this.props;
    const newItem = {
      id: `_new_${Date.now()}_${Math.random().toString(36).slice(2)}`,
      supplier_id: record.supplier_id || null,
      supplier_name: (record.supplier && record.supplier.company_name) || '',
      supplier_item_id: record.id,
      item_name: record.name || '',
      description: record.description || '',
      item_code: record.item_code || '',
      unit_of_measure: record.unit_of_measure || 'Item',
      quantity: 1,
      unit_cost: parseFloat(record.unit_price || record.unit_cost || 0),
      currency: 'GBP',
      tax_rate: 20,
      markup_percentage: 0,
      lead_time_days: 0,
      required_by_date: null,
      notes: '',
      status: 'pending',
      is_ad_hoc: true,
      total_cost: parseFloat(record.unit_price || record.unit_cost || 0),
      total_sell_price: 0,
      line_order: procurementItems.length,
    };
    dispatch(addProcurementItem(newItem));
    dispatch(hideCatalogPicker());
  }

  render() {
    const { onClose } = this.props;
    const { search, items, loading } = this.state;

    const columns = [
      { title: 'Supplier', dataIndex: ['supplier', 'company_name'], key: 'supplier', width: 160 },
      { title: 'Code', dataIndex: 'item_code', key: 'item_code', width: 100 },
      { title: 'Name', dataIndex: 'name', key: 'name' },
      { title: 'Unit', dataIndex: 'unit_of_measure', key: 'unit_of_measure', width: 80 },
      { title: 'Unit Cost', dataIndex: 'unit_price', key: 'unit_price', width: 100, render: v => v ? `£${parseFloat(v).toFixed(2)}` : '-' },
    ];

    return (
      <Modal
        title="Add from Catalog"
        visible
        onCancel={onClose}
        footer={null}
        width={900}
      >
        <Input.Search
          placeholder="Search by name, code or supplier..."
          value={search}
          onChange={this.onSearch}
          style={{ marginBottom: 16 }}
          allowClear
        />
        <Spin spinning={loading}>
          <Table
            dataSource={items}
            columns={columns}
            rowKey="id"
            size="small"
            pagination={{ pageSize: 20 }}
            onRow={record => ({
              onClick: () => this.onSelectItem(record),
              style: { cursor: 'pointer' },
            })}
            locale={{ emptyText: 'No catalog items found' }}
          />
        </Spin>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  procurementItems: state.screens.OrderView.procurementItems,
});

export default connect(mapStateToProps)(CatalogPicker);
